import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import bind from "memoize-bind";

import { SubBar, MainView, SidebarView, Button, PaginationNavigation, Message, Menu } from "lib/index";
import {
  stateSelector,
  initializeView,
  destroyView,
  setParamsWithLocationQuery,
  changeFilters,
  changeFiltersAndResetOffset,
  changePagination,
  fetchRecords,
} from "./index";
import AffiliateListFilters from "./AffiliateListFilters";
import AffiliateListTable from "./AffiliateListTable";

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    sidebarVisible: state.app.sidebarVisible,
    filters: stateSelector(state).filters,
    offset: stateSelector(state).offset,
    limit: stateSelector(state).limit,
    records: stateSelector(state).records.model && stateSelector(state).records.model.records,
    totalCount: stateSelector(state).records.model && stateSelector(state).records.model.meta.total_count,
    aggregations: stateSelector(state).records.model && stateSelector(state).records.model.aggregations,
    fetchDone: stateSelector(state).records.fetchDone,
    fetchLoading: stateSelector(state).records.fetchLoading,
    fetchFailed: stateSelector(state).records.fetchFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        destroyView,
        setParamsWithLocationQuery,
        changeFilters,
        changeFiltersAndResetOffset,
        changePagination,
        fetchRecords,
      },
      dispatch
    )
)
export default class OrdersListView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView();
    this.props.setParamsWithLocationQuery(this.props.location.query);
  }

  componentWillUnmount() {
    this.props.destroyView();
  }

  render() {
    const {
      fetchDone,
      fetchLoading,
      fetchFailed,
      records,
      aggregations,
      filters,
      offset,
      limit,
      totalCount,
      fetchRecords,
      changeFilters,
      changeFiltersAndResetOffset,
      changePagination,
      currentCompany,
      sidebarVisible,
    } = this.props;

    return (
      <SidebarView.Container>
        <SidebarView.Sidebar label={I18n.t("papp.common.filters_title")} extended={sidebarVisible}>
          <AffiliateListFilters
            aggregations={aggregations}
            filters={filters}
            onFiltersChange={(filters) => changeFiltersAndResetOffset(filters)}
            currentCompany={currentCompany}
          />
        </SidebarView.Sidebar>

        <SidebarView.Content hasSidebar={sidebarVisible}>
          <MainView.Container>
            <SubBar hasSidebar={sidebarVisible}>
              <div className="pull-left u-inlineFlexRow">
                <h1>{I18n.t("papp.affiliate.AffiliateListView.title")}</h1>
              </div>
              <div className="pull-right">
                {fetchDone && totalCount > 0 && (
                  <PaginationNavigation
                    offset={offset}
                    limit={limit}
                    totalCount={totalCount}
                    onChange={changePagination}
                    name="affiliateListLimit"
                  />
                )}
              </div>
            </SubBar>

            <MainView.Content grayBackground hasSubBar>
              <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchRecords} />
              {fetchDone && totalCount === 0 && (
                <MainView.DimmerContent
                  icon="sentiment_neutral"
                  title={I18n.t("papp.affiliate.AffiliateListView.no_records_title")}
                >
                  <p>{I18n.t("papp.affiliate.AffiliateListView.no_records_message")}</p>
                </MainView.DimmerContent>
              )}
              {fetchDone && totalCount > 0 && (
                <AffiliateListTable orders={records} start={offset + 1} end={Math.min(offset + limit, totalCount)} />
              )}
            </MainView.Content>
          </MainView.Container>
        </SidebarView.Content>
      </SidebarView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/affiliate/AffiliateListView/AffiliateListView.jsx